import React from 'react';
import Lang from '../Lang/Lang';
import Icon from '../Icon/Icon';

function SeoText(props) {
  const {h1, text} = props;
  const [opened, setOpened] = React.useState(false);

  return(
    <section
      className={`px-5 desktop:px-0 my-10 desktop:my-16 description-block`}>
      <div className={`content ${opened ? '' : 'closed'} relative`}>
        {
          h1 && (
            <h1>{h1}</h1>
          )
        }
        <p dangerouslySetInnerHTML={{__html: text.trim()}}/>
      </div>
    </section>
  );
}

export default SeoText;
